module.exports = __webpack_public_path__ + "static/media/fly0244.e24f4eaf.webp";